// @ts-check
import React from 'react';
import { useContext } from "react";
import ContentPageContext from "@/src/cms/context/ContentPageContext";
import Layout from '@/src/shared/components/Layout';
import ErrorPage from '@/pages/_error';
import ContentHead from "./ContentHead";
import AdminLink from "@/src/shared/components/AdminLink";
import ContentHero from "./ContentHero";
import WebLogImage from "@/src/shared/components/WebLogImage";

/** @param {{ children: import("react").ReactNode }} props */
export default function ContentLayout({ children }) {
  const value = useContext(ContentPageContext);

  if (!value) {
    throw new Error('ContentLayout must be wrapped with ContentPageContext.Provider or ContentPageContextProvider')
  }

  if (value.error) return <ErrorPage status={value.error} />;

  const { sitepageid, meta } = value;

  return (
    <Layout>
      <ContentHead />
      <AdminLink pageID={sitepageid} pageType="content" />
      <ContentHero />
      {children}
      <WebLogImage browserPath sitePageId={sitepageid} title={meta.title} />
    </Layout>
  )
}